var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['appContainer', { delayedFadeIn: _vm.isLoggedIn }]},[_c('AlertBar',_vm._b({},'AlertBar',_vm.alertBar,false)),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }